import { useSelector, useDispatch } from "react-redux";

import {
  openTaskModal,
  setArchiveModalOpen,
} from "app/store/tasks/slice/taskSlice";
import { useState } from "react";

const useTaskTableWrapper = () => {
  const { selectedRowIds, taskModalOpen, archiveModalOpen, singleTaskArchive } =
    useSelector((state) => state.task);
  const dispatch = useDispatch();

  const [rowSelection, setRowSelection] = useState({});

  const handleAddTask = () => {
    dispatch(
      openTaskModal({
        taskModalOpen: true,
        requestType: "POST",
        taskModalTitle: "Add Task",
        selectedTask: {
          id: "",
          description: "",
          status: "To Do",
          account: "",
        },
      })
    );
  };

  const handleArchiveTasks = () => {
    dispatch(setArchiveModalOpen(true));
  };

  return {
    selectedRowIds,
    taskModalOpen,
    handleAddTask,
    handleArchiveTasks,
    archiveModalOpen,
    singleTaskArchive,
    rowSelection,
    setRowSelection,
  };
};

export default useTaskTableWrapper;
